import { CopyInlineLink } from '@/components/CopyInlineLink';

export const ArgsTable = (props: {
  id: string | undefined;
  label: string;
  args: Array<[string, unknown]>;
}) => {
  return (
    <div className="border-1 w-fit min-w-64 max-w-[80ch] overflow-hidden rounded-lg border border-secondary font-mono">
      <table className="w-full">
        <thead className="bg-secondary">
          <tr className="border-b-1 border border-l-0 border-r-0 border-t-0 border-secondary">
            <th colSpan={2} className="p-3 text-left">
              <div className="flex items-center gap-2">
                <span>{props.label}</span>
                {props.id && (
                  <CopyInlineLink
                    className="rounded-full border border-secondary px-1.5 py-0.5 font-sans text-xs font-normal"
                    value={props.id}
                  >
                    ID
                  </CopyInlineLink>
                )}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {props.args.map(([k, v]) => (
            <tr
              key={k}
              className="border-b-1 border border-l-0 border-r-0 border-t-0 border-secondary last:border-b-0"
            >
              <td className="border-r-1 rounded border border-b-0 border-l-0 border-t-0 border-secondary p-3">
                {k}
              </td>
              <td className="border-l-1 whitespace-pre-line rounded border border-b-0 border-r-0 border-t-0 border-secondary p-3">
                {typeof v === 'string'
                  ? v.trim() === ''
                    ? '""'
                    : v
                  : JSON.stringify(v)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
